module.exports = __webpack_public_path__ + "img/sauvignon-blanc.e9ba267a.jpg";